<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    :width="$vuetify.breakpoint.mdAndDown ? '95%' : '80%'"
    :formErrors="formErrors"
    :loading="loading"
    :inlineAddButton="inlineAddButton"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :newCreateButtonLabel="newCreateButtonLabel"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: false,
      pageLoading: false,
      entry: null,
      formErrors: [],      
    };
  },
  props: {
    inlineAddButton: {
      default: false,
      type: Boolean
    },
    newCreateButtonLabel: {
      type: String,
      default: "ADICIONAR BOX"
    },
    modelNameSingular: String,
    extraData: {},
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    // loadServerEntry: function(){
    //   this.loading = false;
    //   this.entry = {id: null, itemIdsAttribute: [], name: "", items: []};
    // },
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_NEW_BUILDING_LEVEL_BOX,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.accountContext.buildingLevelBox;
          // this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.$refs.baseNew.closeDialog();
        this.entry.storageItemLots = []
        console.log("ids", this.entry);
        var self = this;
        this.entry.storageItemLotIdsAttribute.forEach(function(id, i){
          self.entry.storageItemLots.push(self.extraData.accountContext.allItemsInStorage.find( (item) => item.id == id));
        });

        this.$emit("entry-created", this.entry);
        this.resetForm();
        return true;
      }else{
        return false;
      }
    },    
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_BUILDING_LEVEL_BOX = gql`
query{
	accountContext {
    buildingLevelBox {
      id
      name
      storageItemLots{
        id
        name
        additionalInfo
        secondAdditionalInfo
      }
      storageItemLotIdsAttribute
    }
  }
}`;

</script>

<style scoped></style>
